import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import AuthContext from "../../contexts/authContext";
import { Box, Divider } from "@mui/joy";
import { FormControl, MenuItem, Select } from "@mui/material";
import axiosInstance from "../../api/axios";
import toast from "react-hot-toast";
import NearMeIcon from "@mui/icons-material/NearMe";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ViewCustomer({
  openViewCustomer,
  setOpenViewCustomer,
  setCustomerId,
  customerId,
  deleted,
}) {
  const [viewData, setViewData] = useState([]);
  const { userData, setRefresh } = useContext(AuthContext);
  const [custSchemeData, setCustSchemeData] = useState();
  const [openConfirmSchemeComplete, setOpenConfirmSchemeComplete] =
    useState(false);
  const [schemeIdComp, setSchemeIdComp] = useState("");
  const role = localStorage.getItem("role");
  const [schemeStatus, setSchemeStatus] = useState("completed");
  const [customerStatus, setCustomerStatus] = useState("completed");
  const [openConfirmCustomerStatus, setOpenConfirmCustomerStatus] =
    useState(false);
  const [activeTab, setActiveTab] = useState("schemes");

  const handleCompleteSchemeConfirm = async () => {
    try {
      const res = await axiosInstance.put(
        `/custscheme/update/${schemeIdComp}`,
        {
          status: schemeStatus,
        }
      );
      if (res.status === 200) {
        toast.success("Scheme completed successfully");
        setOpenConfirmSchemeComplete(false);
        setSchemeIdComp("");
        setRefresh(true);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to complete scheme");
    }
  };

  const handleCloseCustomerStatus = async () => {
    setOpenConfirmCustomerStatus(false);
    setCustomerStatus("");
  };
  const handleConfirmCustomerStatus = async () => {
    try {
      const res = await axiosInstance.put(
        `/customers/updatestatus/${customerId}`,
        {
          status: customerStatus,
        }
      );
      if (res.status === 200) {
        toast.success("Customer status updated successfully");
        setOpenConfirmCustomerStatus(false);
        setCustomerStatus("");
        handleCloseViewCustomer();
        setRefresh(true);
      }
    } catch (error) {
      toast.error("Failed to update customer status");
    }
  };

  const handleEnlargeImage = (img) => {
    const imageUrl = `https://sakthiapi.mapsapp.in/uploads/${img}`;
    const newWindow = window.open();
    newWindow.document.write(
      `<img src="${imageUrl}" alt="Enlarged Image" style="width:100%;">`
    );
  };

  const handleDeleteCustomerImage = async (img) => {
    if (!img) {
      toast.error("No image to delete");
      return;
    }
    if (window.confirm("Are you sure you want to delete this image?")) {
      try {
        const res = await axiosInstance.put(
          `/customers/deleteimage/${customerId}`
        );
        if (res.status === 200) {
          toast.success("Image deleted successfully");
          setRefresh(true);
        }
      } catch (error) {
        console.log(error);
        toast.error("Failed to delete image");
      }
    }
  };

  useEffect(() => {
    if (customerId) {
      const viewCust = userData?.customers?.find(
        (item) => item._id === customerId
      );

      const custSchemeDatas = userData.custSchemes.filter(
        (item) => item.customerId?._id === customerId
      );

      setCustSchemeData(custSchemeDatas);

      setViewData(viewCust);
    }
  }, [customerId, userData]);

  const handleCloseViewCustomer = () => {
    setOpenViewCustomer(false);
    setCustomerId("");
    setViewData([]);
  };

  const handleCompleteScheme = (id) => {
    setSchemeIdComp(id);
    setOpenConfirmSchemeComplete(true);
  };

  const handleCloseConfirmSchemeComplete = () => {
    setOpenConfirmSchemeComplete(false);
    setSchemeIdComp("");
  };

  return (
    <React.Fragment>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={openViewCustomer}
        onClose={handleCloseViewCustomer}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 600,
            width: "100%",
            bgcolor: "#FEDDDD",

            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
            m: 2,
            overflow: "auto",
            minHeight: "80vh",
            maxHeight: "80vh",
          }}
        >
          <ModalClose
            variant="plain"
            sx={{
              m: 1,
              "& svg": { color: "#800001" },
              "&:hover": {
                backgroundColor: "#800001",
                "& svg": { color: "#fff" },
              },
            }}
          />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Typography
              component="h2"
              id="modal-title"
              level="h4"
              textColor="inherit"
              sx={{ fontWeight: "bold", mb: 1 }}
            >
              {viewData?.name}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                component="p"
                id="modal-desc"
                textColor="inherit"
                sx={{ color: "#555" }}
              >
                {viewData?.mobile}
              </Typography>
              {viewData?.lat && viewData?.long && (
                <Button
                  style={{
                    // border: "2px solid #800001",
                    padding: 1,
                    backgroundColor: "transparent",
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                  component="a"
                  target="_blank"
                  href={`https://www.google.com/maps/dir/?api=1&destination=${viewData.lat},${viewData.long}&travelmode=driving`}
                >
                  <NearMeIcon sx={{ color: "#800001" }} />
                </Button>
              )}
              {viewData && viewData?.LocationImg && (
                <Box
                  onClick={() => {
                    handleEnlargeImage(viewData?.LocationImg);
                  }}
                  component={"img"}
                  src={`https://sakthiapi.mapsapp.in/uploads/${viewData?.LocationImg}`}
                  alt="Customer"
                  sx={{
                    width: { xs: "30px", md: "50px" },
                    height: { xs: "30px", md: "50px" },
                    borderRadius: 1,
                    boxShadow: 2,
                    border: "1px solid #800001",
                    position: "relative",
                  }}
                />
              )}
              {viewData && viewData?.LocationImg && (
                <Button
                  onClick={() => {
                    handleDeleteCustomerImage(viewData?.LocationImg);
                  }}
                  title="Delete Image"
                  sx={{
                    // border: "2px solid #800001",
                    padding: 1,
                    backgroundColor: "transparent",
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                >
                  <DeleteIcon sx={{ color: "#800001" }} />
                </Button>
              )}
            </Box>

            {deleted ? (
              <Typography
                sx={{
                  backgroundColor: "#800001",
                  color: "#fff",
                  p: 1,
                  borderRadius: 8,
                  textTransform: "capitalize",
                }}
              >
                {" "}
                {viewData?.status}
              </Typography>
            ) : (
              <Button
                variant="solid"
                size="sm"
                onClick={() => setOpenConfirmCustomerStatus(true)}
                sx={{
                  backgroundColor: "green",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#800001",
                  },
                  textTransform: "capitalize",
                }}
              >
                {viewData?.status}
              </Button>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              mb: 2,
              mt: 2,
              backgroundColor: "#fff",
              borderRadius: 10,
            }}
          >
            <Button
              onClick={() => setActiveTab("schemes")}
              sx={{
                flex: 1,
                backgroundColor: activeTab === "schemes" ? "#800001" : "#fff",
                color: activeTab === "schemes" ? "#fff" : "#800001",
                borderRadius: 10,
                "&:hover": {
                  backgroundColor:
                    activeTab === "schemes" ? "#800001" : "#ffe8e8",
                },
              }}
            >
              Schemes
            </Button>

            <Button
              onClick={() => setActiveTab("updates")}
              sx={{
                flex: 1,
                backgroundColor: activeTab === "updates" ? "#800001" : "#fff",
                color: activeTab === "updates" ? "#fff" : "#800001",
                borderRadius: 10,
                "&:hover": {
                  backgroundColor:
                    activeTab === "updates" ? "#800001" : "#ffe8e8",
                },
              }}
            >
              Updates
            </Button>
          </Box>
          {activeTab === "schemes" && (
            <>
              {custSchemeData
                ?.sort(
                  (a, b) => new Date(b.joiningDate) - new Date(a.joiningDate)
                )
                .map((item) => {
                  const paymentCount =
                    item.paymentsId?.filter(
                      (p) => p.amountPaid > 0 && p.amountPaid === item.amount
                    ).length || 0;

                  return (
                    <Box
                      key={item._id}
                      sx={{
                        mb: 3,
                        p: 2,
                        backgroundColor: "#fff3f3",
                        borderRadius: 2,
                      }}
                    >
                      {/* HEADER */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 1,
                          gap: 2,
                          flexWrap: "wrap",
                        }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                          <Typography
                            sx={{
                              textTransform: "uppercase",
                              fontWeight: "bold",
                              color: "#800001",
                              fontSize: "16px",
                            }}
                          >
                            {item?.schemeId?.schemeName || "--"}
                          </Typography>

                          <Typography
                            sx={{ color: "#800001", fontSize: "14px" }}
                          >
                            {item?.joiningDate?.split("-").reverse().join("-")}{" "}
                            - {item?.endingDate?.split("-").reverse().join("-")}
                          </Typography>
                        </Box>

                        {/* STATUS */}
                        <Box
                          sx={{ display: "flex", gap: 1, alignItems: "center" }}
                        >
                          <Typography
                            sx={{
                              textTransform: "capitalize",
                              color:
                                item.status === "active"
                                  ? "green"
                                  : item.status === "completed"
                                  ? "#800001"
                                  : "red",
                              fontWeight: "medium",
                            }}
                          >
                            {item.status}
                          </Typography>

                          {!deleted &&
                            role !== "agent" &&
                            item.status === "active" && (
                              <Button
                                size="sm"
                                sx={{
                                  backgroundColor: "#800001",
                                  color: "#fff",
                                }}
                                onClick={() => handleCompleteScheme(item._id)}
                              >
                                Complete
                              </Button>
                            )}
                        </Box>
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      {/* PAYMENTS */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color: "#800001",
                          }}
                        >
                          Payments – {paymentCount} / {item.totalMonths}
                        </Typography>

                        <Typography
                          sx={{
                            fontWeight: "bold",
                            color:
                              item.paymentStatus === "unpaid" ? "red" : "green",
                            textTransform: "capitalize",
                          }}
                        >
                          {item.paymentStatus}
                        </Typography>
                      </Box>

                      {/* PAYMENT LIST */}
                      {item.paymentsId?.length > 0 ? (
                        item.paymentsId.map((payment) => (
                          <Box
                            key={payment._id}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              py: 1,
                              borderBottom: "1px solid #eee",
                            }}
                          >
                            <Typography sx={{ fontSize: "14px", flex: 1 }}>
                              {payment.collectionDate} - {payment.paymentType}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: 600,
                                flex: 1,
                                textAlign: "center",
                              }}
                            >
                              ₹{payment.amountPaid}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "14px",
                                flex: 1,
                                textAlign: "right",
                              }}
                            >
                              {payment.remarks}
                            </Typography>
                          </Box>
                        ))
                      ) : (
                        <Typography
                          sx={{ fontSize: "14px", color: "gray", mt: 1 }}
                        >
                          No payments yet
                        </Typography>
                      )}
                    </Box>
                  );
                })}
            </>
          )}
        </Sheet>
      </Modal>
      {/* Scheme Status Update */}
      <Modal
        open={openConfirmSchemeComplete}
        onClose={handleCloseConfirmSchemeComplete}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 300,
            width: "100%",
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
          }}
        >
          {/* <ModalClose onClick={handleCloseConfirmSchemeComplete} /> */}

          <Typography
            level="h5"
            sx={{ mb: 2, textAlign: "center", fontWeight: "bolder" }}
          >
            Change scheme status?
          </Typography>

          <FormControl sx={{ mb: 3 }} fullWidth>
            {/* <InputLabel>Status</InputLabel> */}
            <Select
              variant="standard"
              value={schemeStatus}
              onChange={(e) => setSchemeStatus(e.target.value)}
              required
              placeholder="Select status"
            >
              <MenuItem value="cancelled">Cancelled</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              variant="outlined"
              onClick={handleCloseConfirmSchemeComplete}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!schemeStatus}
              onClick={handleCompleteSchemeConfirm}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Sheet>
      </Modal>
      {/* Customer Status Update Modal */}
      <Modal
        open={openConfirmCustomerStatus}
        onClose={handleCloseCustomerStatus}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: 300,
            width: "100%",
            bgcolor: "#FEDDDD",
            p: 3,
            borderRadius: "md",
            boxShadow: "lg",
          }}
        >
          {/* <ModalClose onClick={handleCloseConfirmSchemeComplete} /> */}

          <Typography
            level="h5"
            sx={{ mb: 2, textAlign: "center", fontWeight: "bolder" }}
          >
            Change customer status?
          </Typography>

          <FormControl sx={{ mb: 3 }} fullWidth>
            {/* <InputLabel>Status</InputLabel> */}
            <Select
              variant="standard"
              value={customerStatus}
              onChange={(e) => setCustomerStatus(e.target.value)}
              required
              placeholder="Select status"
            >
              <MenuItem value="cancelled">Cancelled</MenuItem>
              <MenuItem value="completed">Completed</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              variant="outlined"
              onClick={handleCloseCustomerStatus}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!schemeStatus}
              onClick={handleConfirmCustomerStatus}
              sx={{
                color: "#fff",
                backgroundColor: "#800001",
                "&:hover": {
                  backgroundColor: "#800001",
                  color: "#fff",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Sheet>
      </Modal>
    </React.Fragment>
  );
}
